// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!./AssessmentDefaults.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Assessment_button__s0GuW {
    border-radius: 28px;
    padding: 8px 16px;
    font-weight: 600;
    font-size: 16px;
}

.Assessment_actionButtonContainer__mBKNd {
    display: flex;
    gap: 5px;
}

.Assessment_actionButtonPurple__-Dxyl {
    background: transparent;
    color: var(--branded-purple);
    border: none;
    border-radius: 30px;
    padding: 16px 24px;
}


.Assessment_actionButton__CDp7M {
    background: transparent;
    color: var(--branded-purple);
    border: none;
    border-radius: 30px;
}

.Assessment_actionButton__CDp7M .p-button {
    background-color: #DEBEED80;
}

.Assessment_sectionMarginBottom__dMif2 {
    margin-bottom: 15px;
}

.Assessment_dataTable__cR6ME {
    border: var(--lightPurple) 15px solid;
    border-radius: 10px;
}

.Assessment_dataTable__cR6ME .p-datatable-thead {
    border-bottom: var(--lightPurple) 10px solid;
}

.Assessment_tabView__BJ6rE .p-tabview .p-tabview-nav {
    border-top-color: white;
    border-left-color: white;
    border-right-color: white;
    height: 43px;
    margin-bottom: 37px;
}

.Assessment_tabView__BJ6rE .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    border-bottom-color: var(--branded-purple);
    color: var(--branded-purple);
    border-width: 0px 0px 3px 0px;
}

.Assessment_matrixContainer__rIq8N {
    margin-bottom: 10px;
}

.Assessment_matrixContainer__rIq8N .p-panel-header {
    background: #C39DD5;
    border-radius: 10px;
}

.Assessment_matrixContainer__rIq8N .p-panel-content {
    border-radius: 10px;
}

.Assessment_groupContainer__pw38M {
    margin-bottom: 10px;
    border: 3px solid var(--branded-light-purple);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    padding-bottom: 6px;
}

.Assessment_groupContainer__pw38M .p-panel-header {
    background: var(--branded-light-purple);
}

.Assessment_questionLayout__dbqyG {
    display: grid;
    grid-template-areas:
        'name'
        'body';
    width: 100%;
    column-gap: 10px;
    border: 3px solid var(--branded-light-purple);
    border-radius: 16px;
    padding: 10px;
    margin-bottom: 5px;
    background: #FFFFFF;
}

.Assessment_questionLayoutWithScore__KJKyE {
    display: grid;
    grid-template-areas:
        'name score'
        'body body';
    grid-template-columns: auto auto;
    width: 100%;
    column-gap: 10px;
    border: 3px solid var(--branded-light-purple);
    border-radius: 16px;
    padding: 10px;
    margin-bottom: 5px;
    background: #FFFFFF;
}

.Assessment_groupContainerHorizontal__59xvw {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
}

.Assessment_groupContainerHorizontal__59xvw .Assessment_questionLayoutWithScore__KJKyE {
    width: 49%;
}

.Assessment_groupContainerHorizontal__59xvw .Assessment_questionLayout__dbqyG {
    width: 49%;
}

.Assessment_questionLayoutName__RxM65 {
    grid-area: name;
    position: relative;
    margin-bottom: 10px;
}

.Assessment_noMarginBottom__ODv\\+e {
    margin-bottom: 0px;
}

.Assessment_questionLayoutName__RxM65 .left {
    text-align: left;
}

.Assessment_questionLayoutName__RxM65 .center {
    text-align: center;
}

.Assessment_questionLayoutName__RxM65 .right {
    text-align: right;
}

.Assessment_questionLayoutScore__n9nvy {
    grid-area: score;
    position: relative;
    margin-bottom: 10px;
    text-align: end;

}

.Assessment_scoreLabel__vfpt7 {
    font-weight: bold;
}

.Assessment_scoreValue__shWnT {
    color: #873CAA;
    font-weight: bold;
}

.Assessment_questionLayoutBody__o2kOG {
    grid-area: body;
    position: relative;
    overflow-y: auto;
}

.Assessment_horizontalQuestion__oin-z .radioGroup {
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
}

.Assessment_questionInputContainer__Hutgs {
    display: flex;
    align-items: center;
    min-height: 100%;
    height: max-content;
}

.Assessment_questionInputContainer__Hutgs .icon {
    display: flex;
    align-items: center;
    background-color: var(--branded-purple);
    color: white;
    height: 42px;
    padding-left: 5px;
    padding-right: 5px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.Assessment_questionInputContainer__Hutgs .formik {
    margin-bottom: 15px;
}

.Assessment_questionInputContainer__Hutgs .p-inputtext {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.Assessment_required__kTld- {
    color: red;
}

.Assessment_selectButton__nRFH- .p-selectbutton .p-button.p-highlight {
    background: var(--branded-purple) !important;
    color: white;
    border-color: var(--branded-purple);
}

.Assessment_selectButton__nRFH- .p-selectbutton .p-button {
    background-color: white !important;
    color: var(--branded-purple);
    border-color: #E7E0F1;

}

.Assessment_selectButton__nRFH- .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
    background-color: white !important;
    color: var(--branded-purple);
}

.Assessment_selectButton__nRFH- .p-button .p-badge {
    color: white;
    background-color: var(--branded-purple);
}

.Assessment_switchControl__rBk\\+g .p-inputswitch {
    border-radius: 50px;
}

.Assessment_switchControl__rBk\\+g .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    border-radius: 50px;
}

.Assessment_switchControl__rBk\\+g .p-inputswitch.p-inputswitch .p-inputswitch-slider {
    border-radius: 50px;
}


.Assessment_switchControl__rBk\\+g .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    border-radius: 25px;
}

.Assessment_switchControl__rBk\\+g .p-inputswitch.p-inputswitch .p-inputswitch-slider:before {
    border-radius: 25px;
}

.Assessment_badge__RTZFh {
    border-radius: 4px;
    padding: 4px 10px 4px 10px;
    font-weight: 600;
    text-align: center;
    width: 100px;
}


.Assessment_badgeCompleted__LsVUY {
    background: var(--branded-traffic-green-bg);
    color: var(--branded-traffic-green);
}

.Assessment_badgePendingRequired__8V9-O {
    background: var(--branded-traffic-red-bg);
    color: var(--branded-traffic-red);
}

.Assessment_badgePending__Mp\\+um {
    background-color: var(--branded-traffic-yellow-bg);
    color: var(--branded-traffic-yellow);
}


.Assessment_InfoOverlayIconContainer__jBp93 {
    color: #883CAE;
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.Assessment_InfoOverlayPanel__nkFEN {
    background-color: #883CAE;
    border: solid black 1px;
}

.Assessment_InfoOverlayText__cgFdv {
    color: white;
}

.Assessment_descriptionElementLarge__PkuOc {
    font-size: large;
    white-space: pre-wrap;
}

.Assessment_descriptionElementMedium__x73DV {
    font-size: medium;
    white-space: pre-wrap;
}

.Assessment_descriptionElementSmall__D5K3N {
    font-size: small;
    white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/styles/assessments/Assessment.module.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;IAC7C,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb;;cAEU;IACV,WAAW;IACX,gBAAgB;IAChB,6CAA6C;IAC7C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb;;mBAEe;IACf,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,6CAA6C;IAC7C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,qBAAqB;;AAEzB;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;IACzC,iCAAiC;AACrC;;AAEA;IACI,kDAAkD;IAClD,oCAAoC;AACxC;;;AAGA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB","sourcesContent":["@import \"./AssessmentDefaults.css\";\n\n.button {\n    border-radius: 28px;\n    padding: 8px 16px;\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.actionButtonContainer {\n    display: flex;\n    gap: 5px;\n}\n\n.actionButtonPurple {\n    background: transparent;\n    color: var(--branded-purple);\n    border: none;\n    border-radius: 30px;\n    padding: 16px 24px;\n}\n\n\n.actionButton {\n    background: transparent;\n    color: var(--branded-purple);\n    border: none;\n    border-radius: 30px;\n}\n\n.actionButton :global(.p-button) {\n    background-color: #DEBEED80;\n}\n\n.sectionMarginBottom {\n    margin-bottom: 15px;\n}\n\n.dataTable {\n    border: var(--lightPurple) 15px solid;\n    border-radius: 10px;\n}\n\n.dataTable :global(.p-datatable-thead) {\n    border-bottom: var(--lightPurple) 10px solid;\n}\n\n.tabView :global(.p-tabview .p-tabview-nav) {\n    border-top-color: white;\n    border-left-color: white;\n    border-right-color: white;\n    height: 43px;\n    margin-bottom: 37px;\n}\n\n.tabView :global(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {\n    border-bottom-color: var(--branded-purple);\n    color: var(--branded-purple);\n    border-width: 0px 0px 3px 0px;\n}\n\n.matrixContainer {\n    margin-bottom: 10px;\n}\n\n.matrixContainer :global(.p-panel-header) {\n    background: #C39DD5;\n    border-radius: 10px;\n}\n\n.matrixContainer :global(.p-panel-content) {\n    border-radius: 10px;\n}\n\n.groupContainer {\n    margin-bottom: 10px;\n    border: 3px solid var(--branded-light-purple);\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n    padding-bottom: 6px;\n}\n\n.groupContainer :global(.p-panel-header) {\n    background: var(--branded-light-purple);\n}\n\n.questionLayout {\n    display: grid;\n    grid-template-areas:\n        'name'\n        'body';\n    width: 100%;\n    column-gap: 10px;\n    border: 3px solid var(--branded-light-purple);\n    border-radius: 16px;\n    padding: 10px;\n    margin-bottom: 5px;\n    background: #FFFFFF;\n}\n\n.questionLayoutWithScore {\n    display: grid;\n    grid-template-areas:\n        'name score'\n        'body body';\n    grid-template-columns: auto auto;\n    width: 100%;\n    column-gap: 10px;\n    border: 3px solid var(--branded-light-purple);\n    border-radius: 16px;\n    padding: 10px;\n    margin-bottom: 5px;\n    background: #FFFFFF;\n}\n\n.groupContainerHorizontal {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 5px;\n}\n\n.groupContainerHorizontal .questionLayoutWithScore {\n    width: 49%;\n}\n\n.groupContainerHorizontal .questionLayout {\n    width: 49%;\n}\n\n.questionLayoutName {\n    grid-area: name;\n    position: relative;\n    margin-bottom: 10px;\n}\n\n.noMarginBottom {\n    margin-bottom: 0px;\n}\n\n.questionLayoutName :global(.left) {\n    text-align: left;\n}\n\n.questionLayoutName :global(.center) {\n    text-align: center;\n}\n\n.questionLayoutName :global(.right) {\n    text-align: right;\n}\n\n.questionLayoutScore {\n    grid-area: score;\n    position: relative;\n    margin-bottom: 10px;\n    text-align: end;\n\n}\n\n.scoreLabel {\n    font-weight: bold;\n}\n\n.scoreValue {\n    color: #873CAA;\n    font-weight: bold;\n}\n\n.questionLayoutBody {\n    grid-area: body;\n    position: relative;\n    overflow-y: auto;\n}\n\n.horizontalQuestion :global(.radioGroup) {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.questionInputContainer {\n    display: flex;\n    align-items: center;\n    min-height: 100%;\n    height: max-content;\n}\n\n.questionInputContainer :global(.icon) {\n    display: flex;\n    align-items: center;\n    background-color: var(--branded-purple);\n    color: white;\n    height: 42px;\n    padding-left: 5px;\n    padding-right: 5px;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.questionInputContainer :global(.formik) {\n    margin-bottom: 15px;\n}\n\n.questionInputContainer :global(.p-inputtext) {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n}\n\n.required {\n    color: red;\n}\n\n.selectButton :global(.p-selectbutton .p-button.p-highlight) {\n    background: var(--branded-purple) !important;\n    color: white;\n    border-color: var(--branded-purple);\n}\n\n.selectButton :global(.p-selectbutton .p-button) {\n    background-color: white !important;\n    color: var(--branded-purple);\n    border-color: #E7E0F1;\n\n}\n\n.selectButton :global(.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover) {\n    background-color: white !important;\n    color: var(--branded-purple);\n}\n\n.selectButton :global(.p-button .p-badge) {\n    color: white;\n    background-color: var(--branded-purple);\n}\n\n.switchControl :global(.p-inputswitch) {\n    border-radius: 50px;\n}\n\n.switchControl :global(.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider) {\n    border-radius: 50px;\n}\n\n.switchControl :global(.p-inputswitch.p-inputswitch .p-inputswitch-slider) {\n    border-radius: 50px;\n}\n\n\n.switchControl :global(.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before) {\n    border-radius: 25px;\n}\n\n.switchControl :global(.p-inputswitch.p-inputswitch .p-inputswitch-slider:before) {\n    border-radius: 25px;\n}\n\n.badge {\n    border-radius: 4px;\n    padding: 4px 10px 4px 10px;\n    font-weight: 600;\n    text-align: center;\n    width: 100px;\n}\n\n\n.badgeCompleted {\n    background: var(--branded-traffic-green-bg);\n    color: var(--branded-traffic-green);\n}\n\n.badgePendingRequired {\n    background: var(--branded-traffic-red-bg);\n    color: var(--branded-traffic-red);\n}\n\n.badgePending {\n    background-color: var(--branded-traffic-yellow-bg);\n    color: var(--branded-traffic-yellow);\n}\n\n\n.InfoOverlayIconContainer {\n    color: #883CAE;\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n}\n\n.InfoOverlayPanel {\n    background-color: #883CAE;\n    border: solid black 1px;\n}\n\n.InfoOverlayText {\n    color: white;\n}\n\n.descriptionElementLarge {\n    font-size: large;\n    white-space: pre-wrap;\n}\n\n.descriptionElementMedium {\n    font-size: medium;\n    white-space: pre-wrap;\n}\n\n.descriptionElementSmall {\n    font-size: small;\n    white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Assessment_button__s0GuW`,
	"actionButtonContainer": `Assessment_actionButtonContainer__mBKNd`,
	"actionButtonPurple": `Assessment_actionButtonPurple__-Dxyl`,
	"actionButton": `Assessment_actionButton__CDp7M`,
	"sectionMarginBottom": `Assessment_sectionMarginBottom__dMif2`,
	"dataTable": `Assessment_dataTable__cR6ME`,
	"tabView": `Assessment_tabView__BJ6rE`,
	"matrixContainer": `Assessment_matrixContainer__rIq8N`,
	"groupContainer": `Assessment_groupContainer__pw38M`,
	"questionLayout": `Assessment_questionLayout__dbqyG`,
	"questionLayoutWithScore": `Assessment_questionLayoutWithScore__KJKyE`,
	"groupContainerHorizontal": `Assessment_groupContainerHorizontal__59xvw`,
	"questionLayoutName": `Assessment_questionLayoutName__RxM65`,
	"noMarginBottom": `Assessment_noMarginBottom__ODv+e`,
	"questionLayoutScore": `Assessment_questionLayoutScore__n9nvy`,
	"scoreLabel": `Assessment_scoreLabel__vfpt7`,
	"scoreValue": `Assessment_scoreValue__shWnT`,
	"questionLayoutBody": `Assessment_questionLayoutBody__o2kOG`,
	"horizontalQuestion": `Assessment_horizontalQuestion__oin-z`,
	"questionInputContainer": `Assessment_questionInputContainer__Hutgs`,
	"required": `Assessment_required__kTld-`,
	"selectButton": `Assessment_selectButton__nRFH-`,
	"switchControl": `Assessment_switchControl__rBk+g`,
	"badge": `Assessment_badge__RTZFh`,
	"badgeCompleted": `Assessment_badgeCompleted__LsVUY`,
	"badgePendingRequired": `Assessment_badgePendingRequired__8V9-O`,
	"badgePending": `Assessment_badgePending__Mp+um`,
	"InfoOverlayIconContainer": `Assessment_InfoOverlayIconContainer__jBp93`,
	"InfoOverlayPanel": `Assessment_InfoOverlayPanel__nkFEN`,
	"InfoOverlayText": `Assessment_InfoOverlayText__cgFdv`,
	"descriptionElementLarge": `Assessment_descriptionElementLarge__PkuOc`,
	"descriptionElementMedium": `Assessment_descriptionElementMedium__x73DV`,
	"descriptionElementSmall": `Assessment_descriptionElementSmall__D5K3N`
};
export default ___CSS_LOADER_EXPORT___;
